import { LogoSVG } from './logo-sm'

export const Logo: React.FC<{
  handler: () => void
}> = (props) => {
  const { handler } = props

  return (
    <h1 className='logo' onClick={handler}>
      <LogoSVG />
      <span>springforms</span>
    </h1>
  )
}
